export * from './phone.pipe';
export * from './capitalize.pipe';
